import { useState } from "react";
import { Button } from "semantic-ui-react";
import { UserData, UserRole } from "../../actions/authentificationActions";
import { AppState } from "../../store/configureStore";
import { useSelector } from "react-redux";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { Redirect } from "react-router-dom";
import { ParameterManagementTable } from "../../components/ParameterManagementTable/ParameterManagementTable";
import { ParameterModal } from "../../components/ParameterManagementTable/ParameterModal";
import { InvolvedCountriesModal } from "../../components/ParameterManagementTable/InvolvedCountriesModal";

export const ParameterManagement = () => {
    const [createParameterOpen, setCreateParameterOpen] = useState<boolean>(false);
    const [countriesModalOpen, setCountriesModalOpen] = useState<boolean>(false);
    const [refreshTriggerFlag, setRefreshTriggerFlag] = useState<boolean>(false);

    const user: UserData = useSelector((state: AppState) => state.user);

    if (user.role === UserRole.Viewer) {
        return <Redirect to="/unauthorized" />;
    }

    return (
        <>
            <div className="input-data-editor-container">
                <div className="container-header">
                    <h1>Parameter management</h1>
                    {user.role === UserRole.Admin && (
                        <div className="container-header-buttons">
                            <Button
                                onClick={() => setCountriesModalOpen(true)}
                                content="Edit involved countries"
                                primary
                            />
                            <Button
                                onClick={() => setCreateParameterOpen(true)}
                                content="Add new parameter"
                                primary
                            />
                        </div>
                    )}
                </div>
                <Breadcrumbs />
                <ParameterManagementTable overview={true} refreshTrigger={refreshTriggerFlag} />
            </div>
            <div className="input-data-editor-container">
                <div className="container-header">
                    <h1>Parameters under development</h1>
                </div>
                <ParameterManagementTable
                    overview={true}
                    refreshTrigger={refreshTriggerFlag}
                    setRefreshTrigger={setRefreshTriggerFlag}
                    isDevelopment
                />
            </div>
            <ParameterModal
                modalOpen={createParameterOpen}
                closeModal={() => setCreateParameterOpen(false)}
                refreshTrigger={() => setRefreshTriggerFlag(!refreshTriggerFlag)}
                isDevelopment={true}
            />
            {countriesModalOpen && (
                <InvolvedCountriesModal
                    modalOpen={countriesModalOpen}
                    closeModal={() => setCountriesModalOpen(false)}
                />
            )}
        </>
    );
};
